import Vue from 'vue'
import { environmentList, sourceIconByType, sourceImgByType } from '@/assets/js/config'
import { existTask, copyInfoByObject } from '@/axios/mediaHub.js'
import Store from '@/store/index'
import { searchObjectInfo, searchDeviceInfo, searchByTime, getObjectAttr, searchCheckAdmin } from '@/axios/search'
import { checkThumbnail, checkCNThumbnail } from '@/axios/base.js'
import i18n from '@/assets/lang/i18n.js'
import errorCodeLang from '@/assets/lang/errorCodeLang'
import MHNotify from '@/assets/js/MHNotify' // 使用 MHNotify 替代直接 Notification [Claude Code]
// 资源池不足通知组件：把原 HTML 字符串 content 升级为可承载 el-button 与后续交互的 SFC [Claude Code]
import InsufficientResources from '@/components/common/notifyTemplates/InsufficientResources.vue'
import moment from 'moment'
let messageTime = null
const Tool = {
  // 返回32位随机数
  return32Str (length = 32) {
    let chars = [
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z',
      'a',
      'b',
      'c',
      'd',
      'e',
      'f',
      'g',
      'h',
      'i',
      'j',
      'k',
      'l',
      'm',
      'n',
      'o',
      'p',
      'q',
      'r',
      's',
      't',
      'u',
      'v',
      'w',
      'x',
      'y',
      'z'
    ]
    let num = ''
    for (let i = 0; i < length; i++) {
      let id = parseInt(Math.random() * 61)
      num += chars[id]
    }
    return num
  },
  dynamicLoadJs (url, callback, id) {
    let script = document.createElement('script')
    script.type = 'text/javascript'
    script.defer = true
    script.id = id || ''
    script.src = url
    if (typeof callback == 'function') {
      script.onerror = () => {
        const parameter = 'failed'
        typeof callback == 'function' && callback(parameter)
      }
      script.onload = () => {
        const parameter = 'true'
        typeof callback == 'function' && callback(parameter)
      }
    }
    document.head.appendChild(script)
  },
  getDuration (timestamp) {
    const totalSeconds = Math.floor(timestamp / 1000)
    const days = Math.floor(totalSeconds / (24 * 60 * 60))
    const hours = Math.floor(totalSeconds / (60 * 60)) % 24
    const minutes = Math.floor(totalSeconds / 60) % 60
    const seconds = totalSeconds % 60

    return `${days > 0 ? days + 'd ' : ''}${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
  },
  getEnvironment () {
    let environment = ''
    const cookieArr = document.cookie.split(';')
    for (const v of cookieArr) {
      const environmentKey = v.split('=')[0].toLowerCase().trim()
      if (environmentList[environmentKey]) {
        environment = environmentList[environmentKey]
        break
      }
    }
    return environment
  },
  setTagCookie (tagKey, tagValue, exdays) {
    let d = new Date()
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
    let expires = d.toUTCString()
    let domain = document.domain.split('.')
    domain = `${domain[1]}.${domain[2]}`
    if (tagKey && tagValue) {
      // 字符串拼接cookie
      window.document.cookie = tagKey + '=' + tagValue + ';path=/;domain=' + domain + ';expires=' + expires
    }
  },
  getDateTime (time) {
    time = time || new Date()
    const year = time.getFullYear()
    const month = time.getMonth() + 1
    const day = time.getDate()
    const hour = this.timeFormat(time.getHours())
    const min = this.timeFormat(time.getMinutes())
    const s = this.timeFormat(time.getSeconds())
    return { year, month, day, hour, min, s }
  },
  timeFormat (time) {
    return time < 10 ? `0${time}` : time
  },
  formatDate (time) {
    const date = new Date(time)
    const y = date.getFullYear()
    let m = date.getMonth() + 1
    m = m.toString().padStart(2, '0')
    let d = date.getDate()
    d = d.toString().padStart(2, '0')
    return y + m + d
  },
  transDateAndTime (value, type) {
    value = Number(value)
    if (!value || value >= 9999999999999) return '---'
    const oDate = new Date(value)
    const oYear = oDate.getFullYear()
    let oMonth = oDate.getMonth() + 1
    let oDay = oDate.getDate()
    let oHour = oDate.getHours()
    let oMin = oDate.getMinutes()
    let oSen = oDate.getSeconds()
    let oMil = oDate.getMilliseconds()
    oHour = oHour <= 9 ? '0' + oHour : oHour
    oMin = oMin <= 9 ? '0' + oMin : oMin
    oSen = oSen <= 9 ? '0' + oSen : oSen
    oMil = oMil <= 99 ? (oMil = oMil <= 9 ? '00' + oMil : '0' + oMil) : oMil
    let oTime = ''
    if (type == 1) {
      oMonth = oMonth <= 9 ? '0' + oMonth : oMonth
      oDay = oDay <= 9 ? '0' + oDay : oDay
      oTime = oMonth + '-' + oDay + ' ' + oHour + ':' + oMin
    } else if (type == 2) {
      oTime = oHour + ':' + oMin + ':' + oSen + ':' + oMil
    } else if (type == 3) {
      oTime = oYear + '/' + oMonth + '/' + oDay
    } else if (type == 4) {
      oTime = oYear + '-' + oMonth + '-' + oDay + ' ' + oHour + ':' + oMin + ':' + oSen
    } else if (type == 5) {
      oMonth = oMonth <= 9 ? '0' + oMonth : oMonth
      oDay = oDay <= 9 ? '0' + oDay : oDay
      oTime = '' + oYear + oMonth + oDay + oHour + oMin + oSen + oMil
    } else if (type == 6) {
      oTime = oHour + ':' + oMin + ':' + oSen
    } else if (type == 7) {
      oMonth = oMonth <= 9 ? '0' + oMonth : oMonth
      oDay = oDay <= 9 ? '0' + oDay : oDay
      oTime = oYear + '-' + oMonth + '-' + oDay
    } else if (type == 8) {
      oTime = '' + oYear + oMonth + oDay + '_' + oHour + oMin + oSen
    } else {
      oTime = oYear + '/' + oMonth + '/' + oDay + ' ' + oHour + ':' + oMin
    }
    return oTime
  },
  formatDaterange (value) {
    const et = new Date().getTime()
    let st = 0
    switch (value) {
      case 'today':
        st = et - 24 * 60 * 60 * 1000
        break
      case 'week':
        st = et - 7 * 24 * 60 * 60 * 1000
        break
      case 'month':
        st = et - 30 * 24 * 60 * 60 * 1000
        break
      default:
        break
    }
    return [st, et]
  },
  getEdnTime (str) {
    const timeList = [
      { st: -10, et: 10, result: 30 },
      { st: 5, et: 25, result: 45 },
      { st: 20, et: 40, result: 60 },
      { st: 35, et: 55, result: 75 },
      { st: 50, et: 70, result: 90 }
    ]
    const date = str ? new Date(str) : new Date()
    const year = date.getFullYear()
    const month = date.getMonth()
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const item = timeList.find(i => i.st <= minute && minute <= i.et)
    const newMin = item.result
    return new Date(year, month, day, hour, newMin, 0)
  },
  differenceObjectId (setA, setB) {
    const _differenceObjectId = new Set(setA)
    for (const elem of setB) {
      _differenceObjectId.delete(elem)
    }
    return _differenceObjectId
  },
  replacer (key, value) {
    if (value instanceof Map) {
      return {
        dataType: 'Map',
        value: Array.from(value.entries()) // or with spread: value: [...value]
      }
    } else {
      return value
    }
  },
  reviver (key, value) {
    if (typeof value === 'object' && value !== null) {
      if (value.dataType === 'Map') {
        return new Map(value.value)
      }
    }
    return value
  },
  sgStorage (item, value) {
    if (arguments.length > 1) {
      if (localStorage.getItem(item) == null) {
        localStorage.setItem(item, value)
      } else if (value != localStorage.getItem(item) && value != undefined) {
        localStorage.setItem(item, value)
      }
    } else {
      return localStorage.getItem(item)
    }
  },
  debounce (fun, delay = 500) {
    // 防抖函数
    let timer = null
    return function (...args) {
      if (timer) {
        clearTimeout(timer)
      }
      timer = setTimeout(() => {
        fun.apply(this, args)
      }, delay)
    }
  },
  throttle (fun, delay) {
    let lastCall = 0

    return function (...args) {
      const now = new Date().getTime()

      if (now - lastCall >= delay) {
        fun.apply(this, args)
        lastCall = now
      }
    }
  },
  checkGroupCallback (arr) {
    let selectObjectIds = []
    let cancelObjectIds = []
    let selectGroup = []
    let selectSource = []
    let checkedGroupNum = 0
    let checkedSourceNum = 0
    let sourceNum = 0
    arr.forEach(k => {
      if (k.checked) {
        checkedGroupNum++
        selectGroup.push({
          type: 'group',
          key: k.groupId + k.groupType,
          id: k.groupId,
          name: k.groupName
        })
      }
      k.objectInfos.forEach(v => {
        sourceNum++
        if (k.checked) {
          selectObjectIds.push(v.objectId)
        } else {
          if (v.isSelect) {
            checkedSourceNum++
            selectObjectIds.push(v.objectId)
            selectSource.push({
              type: 'source',
              key: k.groupId + k.groupType,
              id: v.objectId,
              name: v.name
            })
          } else {
            cancelObjectIds.push(v.objectId)
          }
        }
      })
    })
    // 组全勾选或全不勾选 代表全勾选
    if ((checkedGroupNum == 0 || checkedGroupNum == arr.length) && checkedSourceNum == 0) {
      selectObjectIds = checkedGroupNum ? [...selectObjectIds] : [...cancelObjectIds]
      cancelObjectIds = []
    }
    // 组全不勾选但所有组下的源全部勾选  也代表全勾选
    if (checkedGroupNum == 0 && checkedSourceNum == sourceNum) {
      cancelObjectIds = []
    }
    return { selectObjectIds, cancelObjectIds, checkedGroupNum, checkedSourceNum, selectGroup, selectSource }
  },
  getRMessage (rpid) {
    return new Promise((resolve, reject) => {
      if (!rpid) {
        resolve({})
      } else {
        searchDeviceInfo(rpid).then(res => {
          if (res.data.errorCode == '0x0') {
            // 根据协议的不同，R的端口也不同，proxyAddNum是给kevin代理R接口用的端口
            let portAddNum; let protocol; const proxyAddNum = 201
            if (location.protocol.indexOf('https') > -1) {
              portAddNum = 401
              protocol = 'https://'
            } else {
              portAddNum = 401
              protocol = 'https://'
            }
            const result = res.data.result[0]
            result.proxyPort = Number(result.port) + proxyAddNum
            result.port = Number(result.port) + portAddNum
            result.protocol = protocol
            result.pid = result.peerId
            if (result.portAggregate) {
              result.port = Number(result.portAggregateWeb)
              result.proxyPort = result.port
            }
            resolve(result)
          } else {
            resolve({})
          }
        }).catch(() => {
          // console.log(err)
          resolve({})
        })
      }
    })
  },
  getLastFile (objectId, value) {
    return new Promise((resolve) => {
      const params = {
        sourceObjectId: objectId,
        startTime: value.createTime,
        endTime: value.endTime || 9999999999999,
        sort: 'DESC',
        filterR: false
      }
      searchByTime(params).then(res => {
        if (res.data.errorCode == '0x0') {
          const resData = res.data.result || {}
          const date = new Date().getTime()
          if (date >= value.createTime) {
            const fileObj = {
              file: null,
              fileType: ''
            }
            if (resData.mmaFile && resData.mmaFile.length) {
              fileObj.file = resData.mmaFile[0] || {}
              fileObj.fileType = resData.mmaFile[0] ? 'mma' : ''
            } else if (resData.rrsFile && resData.rrsFile.length) {
              fileObj.file = resData.rrsFile[0] || {}
              fileObj.fileType = resData.rrsFile[0] ? 'rrs' : ''
            }
            resolve(fileObj)
          } else {
            resolve({})
          }
        } else {
          resolve({})
        }
      }).catch(() => {
        resolve({})
      })
    })
  },
  getImgUrl (url, callback) {
    const img = new Image()
    img.onload = function () {
      const size = {
        width: img.width,
        height: img.height
      }
      callback(null, size)
      URL.revokeObjectURL(url)
    }
    img.onerror = function () {
      callback('error', null)
    }
    img.src = url
  },
  sourceTypeMap: {
    pack: 'tvuDevice',
    anywhere: 'tvuDevice',
    grid_pack: 'tvuDevice',
    grid_sdi: 'tvuDevice',
    grid_mediahub: 'tvuDevice',
    ndi: 'NDI',
    hls: 'HLS',
    zoom: 'zoom',
    facebook: 'Facebook',
    tiktok: 'tiktok',
    twitch: 'Twitch',
    twitter: 'X',
    kick: 'Kick',
    youtube: 'YouTube',
    ext: 'other',
    smpte2022: 'other',
    issp: 'ISSP',
    udp: 'UDP',
    sdi: 'SDI',
    rtp: 'RTP-FEC',
    zixi: 'Zixi',
    mxl: 'MXL',
    html: 'HTML',
    rtsppush: 'RTSP Push',
    rtsppull: 'RTSP Pull',
    rtsp: 'RTSP Pull',
    rtmppush: 'RTMP(S) Push',
    rtmppull: 'RTMP(S) Pull',
    rtmp: 'RTMP(S) Pull',
    srtlistener: 'SRT Listener',
    srtcaller: 'SRT Caller',
    srt: 'SRT Caller'
  },
  deviceTypeMap: {
    pack: 'TVU Pack',
    anywhere: 'TVU Anywhere',
    grid_sdi: 'TVU Grid-SDI',
    grid_pack: 'TVU Grid-Pack',
    grid_mediahub: 'TVU Grid-MediaHub'
  },
  mapSourceType (value, flag, from) {
    const { peerId, concreteType, url, tangibleType, tangibleId } = value || {}
    let _peerId = peerId || tangibleId || ''
    let _type = tangibleType || ''
    _type = _type.toLowerCase()
    let _concreteType = concreteType || ''
    _concreteType = _concreteType.toLowerCase()
    let _url = url || ''
    let source_type
    let source_icon
    if (_peerId.indexOf('0000000000000001') > -1) {
      source_type = 'grid_pack'
    } else if (_peerId.indexOf('0000000000000002') > -1) {
      source_type = 'grid_sdi'
    } else if (_peerId.indexOf('0000000000000003') > -1) {
      source_type = 'grid_mediahub'
    } else if (flag && _type != 't' && _type != 'invalidurl') {
      source_type = _type
    } else {
      source_type = _concreteType || _type
    }
    if (source_type == 'rtsp' || source_type == 'rtmp' || source_type == 'srt' || source_type == 'ext') {
      source_type = this.mapSourceTypeByURL(source_type, _url)
    }
    source_icon = sourceIconByType[source_type]

    let obj = { source_icon, sourceExactType: source_type }
    if (flag) {
      let source_img = sourceImgByType[source_type]
      Object.assign(obj, { source_img })
    }
    return obj
  },
  mapSourceTypeByURL (type, url) {
    let source_type = type
    if (type == 'rtsp') {
      if (url.startsWith('rtsppush://')) {
        source_type = 'rtsppush'
      } else {
        source_type = 'rtsppull'
      }
    } else if (type == 'rtmp') {
      if (url.startsWith('rtmppush://')) {
        source_type = 'rtmppush'
      } else {
        source_type = 'rtmppull'
      }
    } else if (type == 'srt') {
      if (url.indexOf('mode=listener') > -1) {
        source_type = 'srtlistener'
      } else {
        source_type = 'srtcaller'
      }
    } else if (url.startsWith('issp://')) {
      source_type = 'issp'
    } else if (url.indexOf('www.facebook.com') > -1) {
      source_type = 'facebook'
    } else if (url.indexOf('www.tiktok.com') > -1 || url.indexOf('www.douyin.com') > -1) {
      source_type = 'tiktok'
    }
    return source_type
  },
  mapDeviceType (value) {
    const { peerId, type, concreteType } = value || {}
    let _peerId = peerId || ''
    let _type = type || ''
    _type = _type.toLowerCase()
    let _concreteType = concreteType || ''
    _concreteType = _concreteType.toLowerCase()
    let source_type
    let source_label
    if (_peerId.indexOf('0000000000000001') > -1) {
      source_type = 'grid_pack'
    } else if (_peerId.indexOf('0000000000000002') > -1) {
      source_type = 'grid_sdi'
    } else if (_peerId.indexOf('0000000000000003') > -1) {
      source_type = 'grid_mediahub'
    } else {
      source_type = _concreteType || _type // 新建的source会弃用concreteType字段，保留使用tangbileType
    }
    source_label = this.deviceTypeMap[source_type]
    return { source_label }
  },
  generateRandomWord (len) {
    const characters = 'abcdefghijklmnopqrstuvwxyz'
    // const wordLength = Math.floor(Math.random() * 10) + 3 // Generate a random length between 3 and 15
    const wordLength = Math.floor(Math.random() * len) + 8
    let randomWord = ''

    for (let i = 0; i < wordLength; i++) {
      randomWord += characters.charAt(Math.floor(Math.random() * characters.length))
    }

    return randomWord
  },
  getAttrConfig (objectId) {
    return new Promise((resolve) => {
      let sourceAttrDTO = {}
      let List = ['tvuRegion', 'boxPoolId', 'region']
      getObjectAttr([objectId], List).then(res => {
        if (res.errorCode == '0x0') {
          const list = res.result || []
          const objectAttr = list[0] || {}
          const attrList = objectAttr.attrList || []
          if (attrList.length) {
            attrList.forEach(item => {
              Array.isArray(item.attrValue) && (sourceAttrDTO[item.attrName] = item.attrValue[0])
            })
          } else {
            sourceAttrDTO = null
          }
        } else {
          sourceAttrDTO = null
        }
        resolve(sourceAttrDTO)
      }).catch(() => {
        // console.log(err)
        sourceAttrDTO = null
        resolve(sourceAttrDTO)
      })
    })
  },
  checkInputStatus (sourceInfo) {
    return new Promise((resolve) => {
      let num = 0
      const { objectId, attributes } = sourceInfo
      let sourceAttrDTO = {}
      let _attributes = attributes || []
      _attributes.forEach(item => {
        Array.isArray(item.attrValue) && (sourceAttrDTO[item.attrName] = item.attrValue[0])
      })
      this.checkBackUpInputStatus(sourceAttrDTO.objectRelationId && sourceAttrDTO.objectRelationId !== objectId ? sourceAttrDTO.objectRelationId : '').then(number => {
        if (number > 0) num++
        if (!sourceAttrDTO || (sourceAttrDTO.region || sourceAttrDTO.tvuRegion)) {
          if (sourceInfo.previewId || sourceInfo.partyCode) {
            resolve(num)
          } else {
            existTask({ sourceObjectId: sourceInfo.objectId }).then(res => {
              let flag = false
              if (res.errorCode == '0x0') {
                flag = Boolean(res.result)
              }
              !flag && num++
              resolve(num)
            }).catch(() => {
              num++
              resolve(num)
            })
          }
        } else {
          resolve(num)
        }
      }).catch(() => {
        resolve(num)
      })
    })
  },
  checkBackUpInputStatus (objectId) {
    return new Promise((resolve) => {
      let num = 0
      if (!objectId) {
        resolve(num)
      } else {
        searchObjectInfo([objectId], ['objectName']).then(res => {
          if (res.code == 0) {
            if (Array.isArray(res.data.list)) {
              const objectInfo = res.data.list[0]
              if (objectInfo) {
                this.getAttrConfig(objectId).then(sourceAttrDTO => {
                  if (sourceAttrDTO && (sourceAttrDTO.region || sourceAttrDTO.tvuRegion)) {
                    existTask({ sourceObjectId: objectId }).then(res => {
                      let flag = false
                      if (res.errorCode == '0x0') {
                        flag = Boolean(res.result)
                      }
                      !flag && num++
                      resolve(num)
                    }).catch(() => {
                      num++
                      resolve(num)
                    })
                  } else {
                    resolve(num)
                  }
                }).catch(() => {
                  resolve(num)
                })
              } else {
                resolve(num)
              }
            } else {
              resolve(num)
            }
          } else {
            resolve(num)
          }
        }).catch(() => {
          resolve(num)
        })
      }
    })
  },
  controlLoading (flag) {
    const loading = document.querySelector('#global-loading')
    if (loading) {
      loading.style.display = flag ? 'block' : 'none'
    }
  },
  async copyText (text, callback) {
    try {
      await navigator.clipboard.writeText(text)
      console.info(680000)
      if (callback && typeof callback == 'function') callback('success')
    } catch (err) {
      console.info(680001, err)
      // 剪贴板API失败时，使用传统textarea方法
      try {
        const textarea = document.createElement('textarea')
        textarea.value = text
        textarea.style.position = 'fixed'
        textarea.style.left = '-999999px'
        textarea.style.top = '-999999px'
        document.body.appendChild(textarea)
        textarea.focus()
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        if (callback && typeof callback == 'function') callback('success')
      } catch (fallbackErr) {
        console.error('Copy failed:', fallbackErr)
        if (callback && typeof callback == 'function') callback('error')
      }
    }
  },
  copyImage (url, callback) {
    const canvas = document.createElement('canvas') // 创建一个画板
    const image = new Image()
    image.setAttribute('crossOrigin', 'Anonymous') // 可能会有跨越问题
    image.src = url
    image.onload = () => { // img加载完成事件
      canvas.width = image.width // 设置画板宽度
      canvas.height = image.height // 设置画板高度
      canvas.getContext('2d').drawImage(image, 0, 0) // 加载img到画板
      const url = canvas.toDataURL('image/png') // 转换图片为dataURL，格式为png
      this.clipboardImg(url, callback) // 调用复制方法
    }
  },
  async clipboardImg (url, callback) {
    try {
      const data = await fetch(url)
      const blob = await data.blob()
      await navigator.clipboard.write([
        new window.ClipboardItem({
          [blob.type]: blob
        })
      ]).then(() => {
        if (callback && typeof callback == 'function') callback('success')
      })
    } catch (err) {
      if (callback && typeof callback == 'function') callback('success')
    }
  },
  isEqual (obj1, obj2) {
    // 检查引用是否相同
    if (obj1 === obj2) return true

    // 检查是否是对象
    if (obj1 == null || obj2 == null || typeof obj1 !== 'object' || typeof obj2 !== 'object') {
      return false
    }

    // 获取对象的键
    const keys1 = Object.keys(obj1)
    const keys2 = Object.keys(obj2)

    // 比较键的长度
    if (keys1.length !== keys2.length) return false

    // 递归比较对象的每个属性
    for (let key of keys1) {
      if (!keys2.includes(key) || !this.isEqual(obj1[key], obj2[key])) {
        return false
      }
    }

    return true
  },
  encryption (pid) {
    let index = Math.floor(pid / 2)
    let preNum = pid.slice(0, index)
    let afternum = pid.slice(index, 16)
    return window.btoa(afternum + '_' + preNum)
  },
  openConfigT (peerId, ip, flag) {
    if (!peerId) return
    const protocol = window.location.protocol
    const strWindowFeatures = 'height=600, width=1027, top=200, left=300, toolbar=no, menubar=no, titlebar=no, scrollbars=no, resizable=no,channelmode=no, location=no, status=no'
    const url = `${protocol}//${Store.state.initConfig.configTUrl}/configT.html`
    window.open(
      `${url}#?peerid=${this.encryption(peerId)}&bindip=${ip == '' ? '' : window.btoa(ip)}&flag=${flag}`,
      '_blank',
      strWindowFeatures
    )
  },
  // key 参数可选，默认 'taskInfo_T_S'；调用方传入不同 key 可避免互相覆盖订阅 [Claude Code]
  sendTaskInfo_T_S (sourceIds, createWebsocket, pageRequestWs, callback, key = 'taskInfo_T_S') {
    createWebsocket.pageRequestFn && createWebsocket.pageRequestFn('stop', key)
    if (!sourceIds || !sourceIds.length) return
    // 需要加上右边live的R
    pageRequestWs.send({
      message: {
        type: 'taskInfo',
        module: 'taskInfo_T_S',
        data: {
          peerIds: sourceIds.join(','),
          crossEnv: 'cn',
          crossEnvType: 'T'
        }
      },
      immediate: true,
      time: 3000,
      key,
      success: (res) => {
        // 后端偶发返回 null/对象/字符串，统一兜底为数组，避免回调里 forEach 抛错；res 也可能为空 [Claude Code]
        let results = Array.isArray(res && res.result) ? res.result : []
        if (results.length) {
          typeof callback === 'function' && callback(results)
        }
        // 需要加上右边live的R
        let taskInfoMsg = {
          type: 'taskInfo',
          module: 'taskInfo_T_S',
          data: {
            peerIds: sourceIds.join(','),
            crossEnv: 'cn',
            crossEnvType: 'T'
          }
        }
        if (pageRequestWs.sendMsgs[key]) {
          pageRequestWs.sendMsgs[key].message = taskInfoMsg
        }
      }
    })
  },
  thumbnailUpdate (viewSourceList) {
    let peerIds = []
    const socketDeviceList = Store.state.socketDeviceList
    const initConfig = Store.state.initConfig
    Object.keys(socketDeviceList).forEach((k) => {
      const v = socketDeviceList[k]
      const Item = viewSourceList.find(item => item == k)
      if (Item) {
        const type = v.type || ''
        const _type = type.toLowerCase()
        const status = v.status
        const thumbnailId = v.peerId || ''
        if (_type == 't' || _type == 'x' || _type == 'grid') {
          if (status != 0 && status != 3 && thumbnailId.indexOf('0000000000000003') == -1) {
            peerIds.push(thumbnailId)
          }
        }
      }
    })
    if (!peerIds.length || !initConfig.blobUrl) {
      Store.commit('updateThumImgTimeFn', {
        current: {},
        last: {},
        env: {}
      })
      return
    }
    checkThumbnail(peerIds).then(async res => {
      let emptyTime = []
      let result = res
      let envObj = {}
      Object.keys(res).forEach(key => {
        envObj[key] = 'com'
        if (!res[key]) {
          // 尝试从中国区拿
          emptyTime.push(key)
        }
      })
      if (emptyTime.length) {
        await checkCNThumbnail(emptyTime).then(resCN => {
          Object.keys(resCN).forEach(key => {
            if (resCN[key]) {
              envObj[key] = 'cn'
            }
          })
          result = Object.assign(result, resCN)
        }).catch(() => { })
      }
      Store.commit('updateThumImgTimeFn', {
        current: result,
        last: Store.state.updateThumImgTime.current,
        env: envObj
      })
    }).catch(() => { })
  },
  formatErrorInfo (response) {
    let tranceId = response.headers.traceid
    let { errorCode, errorInfo, result } = response.data
    // 从 axios config 中取语义化标题 [Claude Code]
    let notifyTitle = response.config.notifyTitle
    let notifyType = 'error'
    if (!response.config.disabledErrorTips && errorCode && errorCode !== '0x0') {
      let content = errorInfo || 'Error'
      // errorCode = '0x8100400B'
      result = result || {}
      if (errorCode == '0x8100400B') {
        // errorCode = '0x8100400B'
        // result = {
        //   Required: {
        //     Cpu: 250,
        //     Memory: 0,
        //     Bandwidth: 0
        //   },
        //   Pool: '',
        //   PoolName: '123',
        //   CurrentPoolTotalRemainingResources: {
        //     Bandwidth: 0,
        //     Cpu: 0,
        //     Memory: 0
        //   },
        //   CurrentBoxRemainingResource: {
        //     Bandwidth: 0,
        //     Cpu: 0,
        //     Memory: 0
        //   }
        // }
        notifyTitle = 'Insufficient resources'
        notifyType = 'warning'
        // 资源池余量不足提示：文案改为详细版（所需/可用 Agent Resource Score + 管理入口） [Claude Code]
        // 通过 new Vue().$createElement 借一个临时 render helper，将 SFC 渲染为 VNode 作为 Notification.message [Claude Code]
        content = new Vue().$createElement(InsufficientResources, {
          props: {
            requiredCpu: (result.Required && result.Required.Cpu) || 0,
            availableCpu: (result.CurrentPoolTotalRemainingResources && result.CurrentPoolTotalRemainingResources.Cpu) || 0,
            poolName: result.PoolName || '',
            params: response.config.data
            // homeUrl 已下沉到组件内从 Store 直取，调用方不再需要传 [Claude Code]
          },
          on: {
            // Manage Agent Box Pools 按钮点击占位，后续如需埋点/二次确认再接入 [Claude Code]
            // 'click-manage-pools': () => { }
          }
        })
      } else if (errorCode == '0x80001201') {
        content = `HeadlessR nodeId ${result.nodeId} <br/>
              Email ${result.email}<br/>
              Transmitter PID ${result.tPeerId} is currently occupied by Linux Receiver PID ${result.rPeerId}. It cannot be taken live by UR receivers.`
      } else if (errorCode == '0x80004000') {
        if (result && result.poolName) {
          content = `Not enough ports are available on the selected box. Please configure additional port mappings on the <a href="${Store.state.initConfig.homeUrl}?activeName=AgentDevices&boxPoolName=${result.poolName}" target="_blank">Port Mapping Page.</a>`
        } else {
          content = `Not enough ports are available on the selected box. Please configure additional port mappings on the <a href="${Store.state.initConfig.homeUrl}?activeName=AgentDevices" target="_blank">Port Mapping Page.</a>`
        }
      } else if (errorCodeLang.en[errorCode]) {
        content = i18n.t(errorCode)
      }
      typeof content == 'string' && (content = content.replace(/\n/g, '<br>')) // 添加换行
      // 非 error 类型（如 info 友好提示）直接使用 content，不包裹 Trace ID / Error Code 结构 [Claude Code]
      const message = notifyType === 'error'
        ? `
            <div class="error-messasge-content">
              ${tranceId ? `<p class="trasnceId"><span class="label">Trace ID: </span><span class="content">${tranceId}</span></p>` : ''}
              <p class="errorCode"><span class="label">Error Code: </span><span class="content">${errorCode}</span></p>
              <p class="message"><span class="label">Error Message: </span><span class="content">${content}</span></p>
            </div>
          `
        : content
      // message 为 VNode 时不能走 innerHTML，否则 Element UI 会把对象序列化成 [object Object] [Claude Code]
      const isHtmlString = typeof message === 'string'
      MHNotify({
        title: notifyTitle ? `${notifyTitle} ${notifyType === 'error' ? 'Failed' : ''}` : 'Error',
        type: notifyType,
        dangerouslyUseHTMLString: isHtmlString,
        message
      })
    }
  },
  formatStringByDate (date) {
    if (i18n.locale == 'zh') {
      return moment(date).format('YYYY/M/D H:mm')
    } else {
      return moment(date).format('MMM D, YYYY [at] h:mmA')
    }
  },
  getVoipStorage (key, type, status) {
    let voip = sessionStorage.getItem('voip')
    voip = voip ? JSON.parse(voip) : {}
    if (type == 'del') {
      if (voip[key]) {
        delete voip[key]
      }
    } else if (type == 'add') {
      voip[key] = {
        peerId: key,
        status
      }
    } else {
      return voip[key]
    }
    sessionStorage.setItem('voip', JSON.stringify(voip))
  },
  formatDestinationType (destInfo) {
    const { mediaType, subType, ioType } = destInfo
    let _mediaType = mediaType || ''
    let _subType = subType || ''
    _mediaType = _mediaType.toLowerCase()
    _subType = _subType.toLowerCase()
    let type = ''
    if (_mediaType == 'o') {
      type = `${_mediaType}-${_subType}-${ioType}`
    } else if (_mediaType == 'srt' || _mediaType == 'hls') {
      type = `${_mediaType}-${ioType}`
    } else {
      type = _mediaType
    }
    return type
  },
  checkObjectAuth (objectId) {
    return new Promise((resolve) => {
      searchCheckAdmin(objectId).then(res => {
        if (res.errorCode == '0x0') {
          const checkAdmin = res.result ? Boolean(res.result) : false
          resolve(checkAdmin)
        }
      }).catch(() => { })
    })
  },
  isValidBroadcastIp (ip) {
    const reg = /^(22[4-9]|23\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/
    return reg.test(ip)
  },
  isValidIp (ip) {
    const ipv4Regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/

    // IPv6 正则（简化版，实际更复杂）
    const ipv6Regex = /^([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}$/

    return ipv4Regex.test(ip) || ipv6Regex.test(ip)
  },
  isValidPort (port) {
    if (!/^[0-9]*$/.test(port) || !port) {
      return false
    }
    const portNum = Number(port)
    return Number.isInteger(portNum) && portNum > 0 && portNum <= 65535
  },
  parseZoomLink (text) {
    // 清理文本
    const cleanedText = text.replace(/\r/g, '').trim()

    const result = {
      meetingId: null,
      password: null
    }

    // 2. 多语言关键词模式（基于 Zoom 客户端实际支持的约 17 种语言）[Claude Code]
    // 英语 / 德语 / 法语 / 西班牙语 / 葡萄牙语 / 意大利语 / 荷兰语 / 波兰语 /
    // 俄语 / 土耳其语 / 印尼语 / 泰语 / 越南语 /
    // 简体中文 / 繁体中文 / 日语 / 韩语
    const MEETING_ID_KEYWORDS = [
      // 英语
      'Meeting ID', 'Meeting-ID', 'MeetingID',
      // 德语（Zoom 德语界面实际用词）
      'Besprechungs-ID',
      // 法语
      'ID de réunion', 'ID de la réunion',
      // 西班牙语
      'ID de reunión', 'ID de la reunión',
      // 葡萄牙语（巴西 & 葡萄牙）
      'ID da reunião', 'ID da Reunião', 'ID de reunião',
      // 意大利语
      'ID riunione', 'ID della riunione',
      // 荷兰语（Zoom 荷兰语界面实际用词）
      'Vergaderings-ID', 'Vergadering-ID',
      // 波兰语
      'ID spotkania',
      // 俄语（Zoom 俄语界面实际用词）
      'ID встречи', 'ID конференции',
      // 土耳其语
      'Toplantı Kimliği', 'Toplantı ID',
      // 印尼语 / 马来语
      'ID Pertemuan', 'ID Rapat',
      // 泰语（Zoom 泰语界面实际用词）
      'ID การประชุม',
      // 越南语
      'ID cuộc họp', 'ID Cuộc họp',
      // 简体中文
      '会议ID', '会议 ID', '会议号',
      // 繁体中文
      '會議ID', '會議 ID', '會議號',
      // 日语（日语汉字"会議"与简体中文"会议"不同）
      '会議ID', '会議 ID', 'ミーティングID', 'ミーティング ID',
      // 韩语
      '회의 ID', '회의ID'
    ].join('|')

    const PASSWORD_KEYWORDS = [
      // 英语
      'Passcode', 'Password',
      // 德语（Zoom 德语界面实际用词）
      'Passwort', 'Kenncode',
      // 法语
      'Mot de passe', 'Code secret',
      // 西班牙语
      'Código de acceso', 'Contraseña',
      // 葡萄牙语（巴西用 Senha）
      'Senha', 'Código de acesso',
      // 意大利语
      'Password', 'Codice',
      // 荷兰语（Zoom 荷兰语界面实际用词）
      'Wachtwoord', 'Wachtwoordcode',
      // 波兰语
      'Hasło', 'Kod dostępu',
      // 俄语（Zoom 俄语界面实际用词）
      'Пароль', 'Код доступа',
      // 土耳其语
      'Şifre', 'Erişim Kodu',
      // 印尼语 / 马来语
      'Kode Sandi', 'Kata Sandi',
      // 泰语（Zoom 泰语界面实际用词）
      'รหัสผ่าน',
      // 越南语（Zoom 越南语界面实际用词）
      'Mật khẩu', 'Mật mã',
      // 简体中文
      '密码', '会议密码', '口令', '验证码',
      // 繁体中文
      '密碼', '會議密碼',
      // 日语（Zoom 日语界面实际用词）
      'パスコード', 'パスワード',
      // 韩语（Zoom 韩语界面实际用词）
      '암호', '비밀번호', '패스코드'
    ].join('|')

    const patterns = {
      meetingId: [
        new RegExp(`(?:${MEETING_ID_KEYWORDS})\\s*[:：]\\s*([\\d\\s\\-]+)`, 'i'),
        new RegExp(`(?:${MEETING_ID_KEYWORDS})`, 'i')
      ],
      password: [
        new RegExp(`(?:${PASSWORD_KEYWORDS})\\s*[:：]\\s*([A-Za-z\\d@#$!_\\-]+)`, 'i'),
        new RegExp(`(?:${PASSWORD_KEYWORDS})`, 'i')
      ]
    }

    // 3. 按行解析文本
    const lines = cleanedText.split('\n')

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].trim()
      if (!line) continue

      // 提取会议ID
      if (!result.meetingId) {
        const match = line.match(patterns.meetingId[0])
        if (match && match[1]) {
          const id = match[1].replace(/[\s\-]/g, '')
          if (this.isValidMeetingId(id)) {
            result.meetingId = id
          }
        }
      }

      // 提取字母数字密码
      if (!result.password) {
        const match = line.match(patterns.password[0])
        if (match && match[1]) {
          result.password = match[1]
        }
      }

      // 尝试从下一行提取（针对换行格式）
      if (i + 1 < lines.length) {
        const nextLine = lines[i + 1].trim()

        // 会议号换行格式
        if (line.match(patterns.meetingId[1]) && !result.meetingId && this.isValidMeetingId(nextLine.replace(/\s/g, ''))) {
          result.meetingId = nextLine.replace(/\s/g, '')
        }

        // 密码换行格式
        if (line.match(patterns.password[1]) && !result.password && nextLine.match(/^[A-Za-z\d]+$/)) {
          result.password = nextLine
        }
      }
    }
    return result
  },

  // 辅助函数：验证会议ID
  isValidMeetingId (id) {
    return !!(id && /^\d{9,11}$/.test(id))
  },
  getQueryTagData (data) {
    const { tagName, classification, groupId, userId } = data
    return JSON.stringify({
      query: `mutation createObjectTag {
        createObjectTag (
          input: {
            tagName: "${tagName}",
            classification: ${classification},
            groupId: "${groupId}",
            userId: "${userId}"
          }
        ) {
          errorCode
          errorInfo
          result {
              tagId
            }
          }
        }`
    })
  },
  updateTagData (tags) {
    return JSON.stringify({
      query: `mutation deleteObjectTag {
      deleteObjectTag (
        input: {
          tagIdList: ${JSON.stringify(tags)}
        }
      ) {
        errorCode
        errorInfo
        }
      }`
    })
  },
  getObjectTag (objectId) {
    return new Promise((resolve) => {
      setTimeout(() => {
        searchObjectInfo([objectId], ['tags']).then(res => {
          if (res.code == 0) {
            const objectList = res.data.list || []
            const object = objectList[0] || {}
            const tags = object.tags || []
            const tagList = []
            const rootGroupId = Store.state.initConfig.groupId
            tags.forEach(e => {
              if (e.classification == 1) {
                e.type = 'Group'
                e.groupId == rootGroupId && tagList.push(e)
              } else if (e.classification == 3) {
                e.type = 'Group-Admin'
                e.groupId == rootGroupId && tagList.push(e)
              } else if (e.classification == 2) {
                e.type = 'Public'
                tagList.push(e)
              } else {
                e.type = 'Personal'
                e.userId == Store.state.userInfo.id && tagList.push(e)
              }
            })
            resolve(tagList)
          } else {
            resolve([])
          }
        }).catch(() => {
          resolve([])
        })
      }, 1000)
    })
  },
  downloadFile (data, filename) {
    const newUrl = URL.createObjectURL(data)
    const elink = document.createElement('a')
    elink.style.display = 'none'
    elink.href = newUrl
    elink.download = filename
    elink.click()
    URL.revokeObjectURL(newUrl)
  },
  copyObjectInfo ({ objectId = '', objectType = '', objectName = '' }) {
    // let versionText = ''
    // const versionList = Store.state.versionList
    // versionList.forEach(v => {
    //   let backendText = v.backendText.replace(/\n/g, '')
    //   backendText = backendText ? `\u00A0\u00A0\u00A0\u00A0${backendText}\n` : ''
    //   let frontendText = v.frontendText.replace(/\n/g, '')
    //   frontendText = frontendText ? `\u00A0\u00A0\u00A0\u00A0${frontendText}\n` : ''
    //   const inner = `  ${v.serviceName}${v.envText}\n${frontendText}${backendText}`
    //   versionText = versionText + inner
    // })
    this.copyText('Generating and copying troubleshooting info for TVU Support')
    if (!objectId || !objectType) return

    // 移除所有旧的复制提示DOM元素
    const oldMessages = document.querySelectorAll('.copying-message')
    oldMessages.forEach(msg => {
      msg.remove()
    })
    if (messageTime) {
      clearTimeout(messageTime)
    }

    // 显示蓝色'复制中'提示，duration: 0 让通知不自动关，等 API 回来再切到 success/error 后 3s 关 [Claude Code]
    const messageInstance = MHNotify({
      title: 'Copy Object Info',
      type: 'info',
      message: 'Generating and copying troubleshooting info for TVU Support',
      customClass: 'copying-message',
      duration: 0
    })

    copyInfoByObject({
      objectId,
      objectType
    }).then(res => {
      if (res.errorCode == '0x0') {
        const detailInfo = res.result.detailInfo || []
        const info = detailInfo[0] || {}
        // if (!info) return
        const processId = detailInfo.map(v => v.processId).join()
        const ip = detailInfo.map(v => v.ip).join()
        const graphIds = info.graphIds?.join()
        const graphEnv = info.graphInfos?.map(v => v.graphEnv).join()
        const boxId = detailInfo.map(v => v.boxId).join()
        const text = [
          `Object Name: ${res.result.objectName}`,
          `Object ID: ${objectId}`,
          `User Email: ${Store.state.userInfo.email}`,
          `Process ID: ${processId || 'Object Inactive'}`,
          `Graph ID: ${graphIds || 'Object Inactive'}`,
          `Graph ENV: ${graphEnv || 'Object Inactive'}`,
          `Box ID: ${boxId || 'Object Inactive'}`,
          `Box IP: ${ip || 'Object Inactive'}`,
          `Date Time: ${moment.utc().format('YYYY-MM-DD HH:mm:ss')} (UTC)`
          // 'Environment: ',
          // `${versionText}`
        ].join('\n')
        this.copyText(text, () => {
          // 获取 Notification 实例对应的 DOM 元素 [Claude Code]
          const messageDom = document.querySelector('.copying-message')
          if (messageDom) {
            // 切 root class 让 reset.less 的 success-detail-notification 颜色生效 [Claude Code]
            messageDom.className = messageDom.className.replace(/info-detail-notification/g, 'success-detail-notification')
            // Notification 的图标节点是 .el-notification__icon [Claude Code]
            const iconDom = messageDom.querySelector('.el-notification__icon')
            if (iconDom) {
              iconDom.className = iconDom.className.replace(/el-icon-info/g, 'el-icon-success')
            }
            // Notification 文案在 .el-notification__content > p 里 [Claude Code]
            const contentDom = messageDom.querySelector('.el-notification__content p')
            if (contentDom) {
              contentDom.textContent = 'Troubleshooting Information Copied'
            }
            // 切到成功态后 3s 关闭 [Claude Code]
            messageTime = setTimeout(() => {
              messageInstance.close()
            }, 3000)
          }
        })
      } else {
        // 获取 Notification 实例对应的 DOM 元素 [Claude Code]
        const messageDom = document.querySelector('.copying-message')
        if (messageDom) {
          // 切 root class 让 reset.less 的 error-detail-notification 颜色生效 [Claude Code]
          messageDom.className = messageDom.className.replace(/info-detail-notification/g, 'error-detail-notification')
          // Notification 的图标节点是 .el-notification__icon [Claude Code]
          const iconDom = messageDom.querySelector('.el-notification__icon')
          if (iconDom) {
            iconDom.className = iconDom.className.replace(/el-icon-info/g, 'el-icon-error')
          }
          // Notification 文案在 .el-notification__content > p 里 [Claude Code]
          const contentDom = messageDom.querySelector('.el-notification__content p')
          if (contentDom) {
            contentDom.textContent = 'Copy failed'
          }
          // 切到错误态后 3s 关闭 [Claude Code]
          messageTime = setTimeout(() => {
            messageInstance.close()
          }, 3000)
        }
      }
    }).catch(() => {
      // 获取 Notification 实例对应的 DOM 元素 [Claude Code]
      const messageDom = document.querySelector('.copying-message')
      if (messageDom) {
        // 切 root class 让 reset.less 的 error-detail-notification 颜色生效 [Claude Code]
        messageDom.className = messageDom.className.replace(/info-detail-notification/g, 'error-detail-notification')
        // Notification 的图标节点是 .el-notification__icon [Claude Code]
        const iconDom = messageDom.querySelector('.el-notification__icon')
        if (iconDom) {
          iconDom.className = iconDom.className.replace(/el-icon-info/g, 'el-icon-error')
        }
        // Notification 文案在 .el-notification__content > p 里 [Claude Code]
        const contentDom = messageDom.querySelector('.el-notification__content p')
        if (contentDom) {
          contentDom.textContent = 'Copy failed'
        }
        // 切到错误态后 3s 关闭 [Claude Code]
        messageTime = setTimeout(() => {
          messageInstance.close()
        }, 2000)
      }
    })
  },
  truncateDecimal (num, digits = 3) {
    const factor = Math.pow(10, digits)
    return Math.trunc(num * factor) / factor
  }
}
export default Tool
